(() => {
  const indexes = document.querySelectorAll('[data-catalog-index]');

  indexes.forEach((index) => {
    const tabs = Array.from(index.querySelectorAll('[data-catalog-tab]'));
    const panels = Array.from(index.querySelectorAll('[data-catalog-panel]'));
    const nextButton = index.querySelector('[data-catalog-next]');

    if (!tabs.length || !panels.length) return;

    const activate = (tab, moveFocus = false, scrollTab = true) => {
      const target = tab.dataset.catalogTab;

      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        const active = panel.dataset.catalogPanel === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      if (scrollTab) tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight') nextIndex = (tabIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex === null) return;
        event.preventDefault();
        activate(tabs[nextIndex], true);
      });
    });

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const currentIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        const nextIndex = (currentIndex + 1) % tabs.length;
        activate(tabs[nextIndex], false);
      });
    }

    const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    activate(selected, false, false);
  });
})();
